// extracted by mini-css-extract-plugin
export default {"arrow":"styles_arrow__0jR-Y","dataLink":"styles_dataLink__AOu-D"};